import { useCallback } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useChainId } from '@occc-app/Chain/hooks';
import { Earning_Mechanism_Typename } from '@occc/graphql';

export const useMakeOffersFilter = () => {
  const chainId = useChainId();
  return useCallback(
    (search: string) => ({
      chainIdEquals: chainId,
      search: search || undefined,
      earningMechanismTypenameIncludes: [Earning_Mechanism_Typename.EarningMechanismLoyaltyEvent],
    }),
    [chainId],
  );
};
